import React, { useState } from 'react'
import styled from 'styled-components'
import Paragraph from './Paragraph'

interface TooltipProps {
  children: React.ReactNode
  message: string | number | React.ReactNode
  width?: number
  disabled?: boolean
  position?: 'top' | 'bottom' | 'left' | 'right'
}

const Tooltip: React.FC<TooltipProps> = ({
                                           children,
                                           message,
                                           width,
                                           disabled,
                                           position = 'top'
                                         }) => {
  const [isVisible, setVisibility] = useState(false)

  return (
    <Wrapper onMouseEnter={() => !disabled && setVisibility(true)} onMouseLeave={() => setVisibility(false)}>
      {children}
      {isVisible && (
        <TooltipMessage
          text={message}
          style={{ width: width ? `${width}px` : 'auto' }}
          $position={position}
        />
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
    display: inline-block;
    position: relative;
`

const TooltipMessage = styled(Paragraph)<{ $position: string }>`
    min-width: 132px;
    background-color: #3b3b3b;
    color: white;
    position: absolute;
    padding: 5px 10px;
    border-radius: 5px;
    z-index: 999;
    left: 50%;
    transform: translateX(-50%);

    ${({ $position }) => {
        switch ($position) {
            case 'top':
                return `
          bottom: 100%;
          margin-bottom: 5px;
        `;
            case 'bottom':
                return `
          top: 100%;
          margin-top: 5px;
        `;
            case 'left':
                return `
          inset-inline-end: 100%;
          margin-inline-end: 5px;
          top: 50%;
          transform: translate(0, -50%);
        `;
            case 'right':
                return `
          inset-inline-start: 100%;
          margin-inline-start: 5px;
          top: 50%;
          transform: translate(0, -50%);
        `;
            default:
                return `
          bottom: 100%;
          margin-bottom: 5px;
        `;
        }
    }}
`

export default Tooltip